import { history } from 'utils'
import { crudService } from '../_services'
import { stringUtils } from 'utils'
import { toast } from 'react-toastify'

export const categoriaProdutoAction = {
  getCategoria,
  getCategoriaSelect,
  addCategoria,
  getCategoriaById,
  onChangeProps,
  editCategoriaInfo,
  editCategoriasDetails,
  createCategoria,
  deleteCategoriaById,
  clear,
  clearAll
}

let filterModel = {
  Page: 0,
  Limit: 10,
  Term: ''
};

function getCategoria(filterModel, showWaiting) {
  return (dispatch) => {
    let apiEndpoint = 'categoriasProdutos' + stringUtils.serialize(filterModel);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeCategoriasList(response.data.items, response.data.totalRows))
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

function getCategoriaSelect() {
  return (dispatch) => {
    let apiEndpoint = 'categoriasProdutos/select';
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeCategoriasList(response.data, 0))
      })
      .catch((err) => {
        console.log(err.response);
        return err.response;
      })
  }
}

function createCategoria(payload) {
  return (dispatch) => {
    dispatch(isLoading())

    let apiEndpoint = 'categoriasProdutos/'
    crudService.post(apiEndpoint, payload)
      .then((response) => {
        if (response.request != undefined && response.request.status === 200) {
          dispatch(createCategoriaInfo())
          toast.success('Feito! Cadastro realizado com sucesso! 😎')
          dispatch(clear())

          history.push(`/categoriasProdutos`)
        } else {
          toast.err('Oops! Erro ao cadastrar Categoria de Produto! 😥')
        }
      }).catch((err) => {
        toast.error('Oops! Erro ao cadastrar Categoria de Produto! 😥')
        return err.response;
      }).finally(() => {
        dispatch(notIsLoading())
        dispatch(getCategoria(filterModel))
      })
  }
}

function getCategoriaById(id) {
  return (dispatch) => {
    let apiEndpoint = 'categoriasProdutos/' + id
    crudService.get(apiEndpoint).then((response) => {
      dispatch(editCategoriasDetails(response.data))
    })
  }
}

function onChangeProps(props, event) {
  return (dispatch) => {
    if (event.target.type === 'checkbox') {
      dispatch(handleOnChangeProps(props, event.target.checked))
    } else {
      dispatch(handleOnChangeProps(props, event.target.value))
    }
  }
}

function editCategoriaInfo(id, payload, redirect) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'categoriasProdutos/' + id
    crudService.put(apiEndpoint, payload)
      .then((response) => {
        if (response.request != undefined && response.request.status === 200) {
          dispatch(updatedCategoriaInfo())
          dispatch(clear())

          history.push(`/categoriasProdutos`)
        }
      }).catch((err) => {
        toast.error('Oops! Erro ao atualizar Categoria de Produto! 😥')
        return err.response;
      }).finally(() => {
        dispatch(notIsLoading())
        dispatch(getCategoria(filterModel))
      })
  }
}

function deleteCategoriaById(id) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'categoriasProdutos/' + id
    crudService.deleteDetail(apiEndpoint).then(() => {
      dispatch(deleteCategoriasDetails())
      dispatch(getCategoria(filterModel))
      dispatch(notIsLoading())
      history.push('/categoriasProdutos')
    })
  }
}

export function addCategoria(payload) {
  return [{ type: 'ADD_CATEGORIAPRODUTO', categoriaProduto: payload }, clear()]
}

export function changeCategoriasList(categoriaProduto, totalRows) {
  return {
    type: 'FETCHED_ALL_CATEGORIAPRODUTO',
    categoriaProduto: categoriaProduto,
    totalRegistros: totalRows
  }
}

export function clear() {
  return {
    type: 'CATEGORIAPRODUTO_CLEAR'
  }
}

export function clearAll() {
  return {
    type: 'CATEGORIAPRODUTO_CLEAR_ALL'
  }
}

export function handleOnChangeProps(props, value) {
  return {
    type: 'CATEGORIAPRODUTO_HANDLE_ON_CHANGE',
    props: props,
    value: value
  }
}

export function editCategoriasDetails(categoriaProduto) {
  return [
    { type: 'CATEGORIAPRODUTO_DETAIL', categoriaProduto },
  ]
}

export function updatedCategoriaInfo() {
  return {
    type: 'CATEGORIAPRODUTO_UPDATED'
  }
}

export function createCategoriaInfo() {
  return {
    type: 'CATEGORIAPRODUTO_CREATED_SUCCESSFULLY'
  }
}

export function deleteCategoriasDetails() {
  return {
    type: 'DELETED_CATEGORIAPRODUTO_DETAILS'
  }
}
export function isLoading() {
  return {
    type: 'CATEGORIAPRODUTO_ISLOADING'
  }
}

export function notIsLoading() {
  return {
    type: 'CATEGORIAPRODUTO_NOTISLOADING'
  }
}
